var _path, _rect, _rect2, _rect3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWebsiteSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 32,
    viewBox: "0 0 160 130",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0C4.47715 0 0 4.47716 0 10V90C0 95.5229 4.47715 100 10 100H150C155.523 100 160 95.5228 160 90V10C160 4.47715 155.523 0 150 0H10ZM15 10C12.2386 10 10 12.2386 10 15V85C10 87.7614 12.2386 90 15 90H145C147.761 90 150 87.7614 150 85V15C150 12.2386 147.761 10 145 10H15Z",
    fill: "current"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 100,
    width: 10,
    height: 20,
    fill: "current"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 100,
    width: 10,
    height: 20,
    fill: "current"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 120,
    width: 80,
    height: 10,
    rx: 5,
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsiteSvg);
export default __webpack_public_path__ + "static/media/websiteSVG.dd558eb50d27f956096b599b26a5eb4e.svg";
export { ForwardRef as ReactComponent };